import { render, staticRenderFns } from "./SalesSummaryNew.vue?vue&type=template&id=1bfe0720&scoped=true&"
import script from "./SalesSummaryNew.vue?vue&type=script&lang=ts&"
export * from "./SalesSummaryNew.vue?vue&type=script&lang=ts&"
import style0 from "./SalesSummaryNew.vue?vue&type=style&index=0&id=1bfe0720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe0720",
  null
  
)

export default component.exports